import {
  MESSAGE_ORDER_TYPE_FIRST,
  MESSAGE_ORDER_TYPE_LAST,
  MESSAGE_ORDER_TYPE_MIDDLE
} from '../constants';

const getMessageOrder = (prevMessageType, currentMessageType, nextMessageType) => {
  if (prevMessageType !== currentMessageType) {
    return MESSAGE_ORDER_TYPE_FIRST;
  }

  if (prevMessageType === currentMessageType && nextMessageType === currentMessageType) {
    return MESSAGE_ORDER_TYPE_MIDDLE;
  }

  if (nextMessageType !== currentMessageType) {
    return MESSAGE_ORDER_TYPE_LAST;
  }

  return MESSAGE_ORDER_TYPE_FIRST;
};

export default getMessageOrder;
